import { render } from "./AgentHandoffElement.vue?vue&type=template&id=1efc3b1c&scoped=true"
import script from "./AgentHandoffElement.vue?vue&type=script&lang=js"
export * from "./AgentHandoffElement.vue?vue&type=script&lang=js"

import "./AgentHandoffElement.vue?vue&type=style&index=0&id=1efc3b1c&scoped=true&lang=css"

import exportComponent from "../../../../peelochat-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1efc3b1c"]])

export default __exports__